"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M2 1v5H1a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1v-3h3a1 1 0 001-1V3c0-.55-.45-1-1-1H9.42L7.71.3A.966.966 0 007 0H3c-.55 0-1 .45-1 1zm6.596 3H14v6h-2V7a1 1 0 00-1-1H4V2h2.584l2.012 2zM7 8h2l-4 6H3l4-6z"];
//# sourceMappingURL=root-folder.js.map